import {
  genElBoolean,
  genElText,
} from "@components/utils/EditorDialogElementGenerator";
import SectionCard from "./section-card";
import SignatureRow from "./signature-row";

const signers = [
  { name: "diarsip_oleh", label: "Diarsip", title: "Admin Transport" },
];

// VI. Kelengkapan Dokumen (Transport)
const SectionKelengkapan = (props) => {
  const { data, setData, error, stage, saving, onSave, signProps, cardProps } = props;

  const disabled = stage !== "active";

  return (
    <SectionCard
      {...cardProps}
      code="VI"
      title="Kelengkapan Dokumen"
      role="Transport"
      stage={stage}
      saving={saving}
      onSave={onSave}
      signatures={
        <SignatureRow
          signers={signers}
          data={data}
          canSign={stage === "active" && !!data.id}
          {...signProps}
        />
      }
    >
      {genElBoolean({
        field: "is_doc_form_permintaan",
        name: "Form Permintaan",
        data,
        setData,
        error,
        disabled,
        labelTrue: "Lengkap",
        labelFalse: "Belum",
      })}
      {genElBoolean({
        field: "is_doc_bon_spbu_asli",
        name: "Bon SPBU Asli",
        data,
        setData,
        error,
        disabled,
        labelTrue: "Lengkap",
        labelFalse: "Belum",
      })}
      {genElBoolean({
        field: "is_doc_npp",
        name: "NPP",
        data,
        setData,
        error,
        disabled,
        labelTrue: "Lengkap",
        labelFalse: "Belum",
      })}
      {genElText({
        field: "nomor_npp",
        name: "Nomor NPP",
        data,
        setData,
        error,
        disabled: disabled || !(data.is_doc_npp > 0),
      })}
    </SectionCard>
  );
};

export default SectionKelengkapan;
